function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33333 8.66667C8.05821 8.66667 8.64583 8.06971 8.64583 7.33333C8.64583 6.59695 8.05821 6 7.33333 6C6.60846 6 6.02083 6.59695 6.02083 7.33333C6.02083 8.06971 6.60846 8.66667 7.33333 8.66667Z",
  fill: "#1F2939"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.29698 7.33333L5.01735 4.05371L4.07802 5L7.35417 8.27614L8.29698 7.33333Z",
  fill: "#1F2939"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.33333 0C3.28325 0 0 3.28325 0 7.33333C0 10.2915 1.7515 12.8405 4.27402 14H10.3926C12.9152 12.8405 14.6667 10.2915 14.6667 7.33333C14.6667 3.28325 11.3834 0 7.33333 0ZM1.33333 7.33333C1.33333 4.01962 4.01962 1.33333 7.33333 1.33333C10.647 1.33333 13.3333 4.01962 13.3333 7.33333C13.3333 9.68915 11.9756 11.7279 10 12.7097C9.19669 13.1089 8.29123 13.3333 7.33333 13.3333C6.37544 13.3333 5.46997 13.1089 4.66667 12.7097C2.69104 11.7279 1.33333 9.68915 1.33333 7.33333Z",
  fill: "#1F2939"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66667 12.7097C5.46997 13.1089 6.37544 13.3333 7.33333 13.3333C8.29123 13.3333 9.19669 13.1089 10 12.7097H4.66667Z",
  fill: "#1F2939"
});

function SvgMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.1530bf14.svg";
export { ForwardRef as ReactComponent };